import { useAuthFeatureAuthCheckQuery } from "../services/feature-auth";

export function useFeatureAuth(feature: string): boolean {
  const { data } = useAuthFeatureAuthCheckQuery({ feature });

  if (!data) {
    return false;
  }

  return data.hasAccess;
}
